module.exports = __webpack_public_path__ + "img/result-02.367828be.jpg";